import { render, staticRenderFns } from "./OANavbar.vue?vue&type=template&id=3494d3e8&scoped=true&"
import script from "./OANavbar.vue?vue&type=script&lang=js&"
export * from "./OANavbar.vue?vue&type=script&lang=js&"
import style0 from "./OANavbar.vue?vue&type=style&index=0&id=3494d3e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494d3e8",
  null
  
)

export default component.exports